module.exports = "https://cdn2-fs.clearscore.com/flux/images/a2619b32c6de9f14cdd1b36eadb603f5.jpg";